(() => {
  const root = (window.KOMModules = window.KOMModules || {});

  root.setupConsentTracking = () => {
    const trackingConfig = window.KOM_TRACKING_CONFIG || {};
    const gtmContainerId = String(trackingConfig.gtmContainerId || 'GTM-PDDRCJR9').trim();
    const matomoUrl = String(trackingConfig.matomoUrl || 'https://stats.factorideas.com').trim().replace(/\/+$/, '');
    const matomoSiteId = String(trackingConfig.matomoSiteId || '10').trim();

    let gtmLoaded = false;
    let matomoLoaded = false;
    let matomoImageLoaded = false;

    const loadScript = (src, id) => {
      if (!src) {
        return;
      }

      if (id && document.getElementById(id)) {
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      if (id) {
        script.id = id;
      }
      document.head.appendChild(script);
    };

    const enableGtm = () => {
      if (gtmLoaded || !gtmContainerId) {
        return;
      }

      if (window.google_tag_manager && window.google_tag_manager[gtmContainerId]) {
        gtmLoaded = true;
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      loadScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmContainerId)}`, 'kom-gtm-loader');

      const hasNoscript = document.getElementById('kom-gtm-noscript');
      if (!hasNoscript && document.body) {
        const noscript = document.createElement('noscript');
        noscript.id = 'kom-gtm-noscript';
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmContainerId)}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.insertAdjacentElement('afterbegin', noscript);
      }

      gtmLoaded = true;
    };

    const enableMatomo = () => {
      if (matomoLoaded || !matomoUrl || !matomoSiteId) {
        return;
      }

      window._paq = window._paq || [];
      window._paq.push(['trackPageView']);
      window._paq.push(['enableLinkTracking']);
      window._paq.push(['setTrackerUrl', `${matomoUrl}/matomo.php`]);
      window._paq.push(['setSiteId', matomoSiteId]);
      loadScript(`${matomoUrl}/matomo.js`, 'kom-matomo-loader');
      matomoLoaded = true;
    };

    const enableMatomoImageTracker = () => {
      if (matomoImageLoaded || !matomoUrl || !matomoSiteId) {
        return;
      }

      const existing = document.getElementById('kom-matomo-image-tracker');
      if (existing) {
        matomoImageLoaded = true;
        return;
      }

      const img = document.createElement('img');
      img.id = 'kom-matomo-image-tracker';
      img.referrerPolicy = 'no-referrer-when-downgrade';
      img.src = `${matomoUrl}/matomo.php?idsite=${encodeURIComponent(matomoSiteId)}&rec=1`;
      img.alt = '';
      img.style.border = '0';
      img.style.position = 'absolute';
      img.style.width = '1px';
      img.style.height = '1px';
      img.style.opacity = '0';
      img.style.pointerEvents = 'none';
      document.body.appendChild(img);
      matomoImageLoaded = true;
    };

    window.addEventListener('cmp:consent-changed', (event) => {
      const granted = event?.detail?.granted || {};
      const analyticsGranted = Boolean(granted.analytics);

      if (analyticsGranted) {
        enableGtm();
        enableMatomo();
        enableMatomoImageTracker();
      }
    });
  };
})();
